import { Modal } from "react-bootstrap";
import { useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { videoInsert } from "../../apis/api/GalleryApis";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { toast } from "react-toastify"
import { MediaGet } from "../../apis/api/GalleryApis";


const VideoUpload = ({ show, handleClose }) => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors },
    reset,
  } = useForm();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("video/")) {
      setSelectedFile(file);
      clearErrors("file");
    } else {
      setSelectedFile(null);
      setError("file", {
        type: "manual",
        message: "Please upload a valid video file.",
      });
    }
  };

  const removeFile = () => {
    setSelectedFile(null);
  };

  const onSubmit = async (data) => {
    const userid = Cookies.get("userID");
    const companyid = Cookies.get("company_id")
    if (!selectedFile) {
      setError("file", {
        type: "manual",
        message: "Please select a video file.",
      });
      return;
    }

    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("file", selectedFile);
    formData.append("userid", userid);
    formData.append("companyid", companyid);

    try {
      const res = await dispatch(videoInsert(formData));
      if (res.payload.status === "success") {
        dispatch(MediaGet({ company_id: companyid }))
        toast.success("video inserted succesfully")
      }
      else { toast.error("error while inserting video !") }





      reset();
      setSelectedFile(null);
      handleClose();
    } catch (error) {
      console.error("Video upload failed:", error);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="md" centered>
      <Modal.Header closeButton>
        <Modal.Title>Upload Video</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          {/* Video Title */}
          <input
            type="text"
            placeholder="Enter Video Title"
            className="form-control mb-2"
            {...register("title", { required: "Title is required" })}
          />
          {errors.title && (
            <p className="text-danger mb-2">{errors.title.message}</p>
          )}

          {/* Video File Upload */}
          {!selectedFile && (
            <div
              className="header12"
              onClick={() => fileInputRef.current.click()}
              style={{ cursor: "pointer" }}
            >
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M7 10V9C7 6.23858 9.23858 4 12 4C14.7614 4 17 6.23858 17 9V10C19.2091 10 21 11.7909 21 14C21 15.4806 20.1956 16.8084 19 17.5M7 10C4.79086 10 3 11.7909 3 14C3 15.4806 3.8044 16.8084 5 17.5M7 10C7.43285 10 7.84965 10.0688 8.24006 10.1959M12 12V21M12 12L15 15M12 12L9 15"
                  stroke="#000"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <p>Browse File to upload!</p>
            </div>
          )}

          {errors.file && (
            <p className="text-danger mb-2">{errors.file.message}</p>
          )}

          {/* Preview Video */}
          {selectedFile && (
            <div className="preview-container mb-3">
              <div className="preview-item position-relative">
                <video className="preview-media w-100" controls>
                  <source
                    src={URL.createObjectURL(selectedFile)}
                    type={selectedFile.type}
                  />
                  Your browser does not support the video tag.
                </video>
                <button
                  className="remove-btn position-absolute top-0 end-0 btn btn-sm btn-danger"
                  type="button"
                  onClick={removeFile}
                >
                  ✖
                </button>
              </div>
            </div>
          )}

          <input
            ref={fileInputRef}
            type="file"
            accept="video/*"
            hidden
            onChange={handleFileChange}
          />

          <Modal.Footer className="px-0">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Upload
            </button>
          </Modal.Footer>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default VideoUpload;
